import React from 'react';

import { twMerge } from 'tailwind-merge';

import type { IconProps } from 'components/icon/icon';
import Icon from 'components/icon/icon';
import Typography from 'components/typography/typography';

export interface RadioButtonElementProps {
  title?: string;
  iconProps?: IconProps;
  active?: boolean;
  location?: 'start' | 'middle' | 'end';
  onClick?: () => void;
  className?: string;
  typographyClassName?: string;
}

export const RadioButtonElement: React.FC<RadioButtonElementProps> = (
  props,
) => {
  const { title, iconProps, active, location, onClick } = props;

  const buttonClassNames = twMerge(
    'h-10 py-2 px-6 ',
    'flex flex-row items-center gap-2',
    'bg-white',
    !active &&
      'text-gray-500 focus:bg-gradient-to-r focus:from-[rgba(0,0,0,0.04)] focus:to-[rgba(0,0,0,0.04)] focus:bg-white',
    !active &&
      'hover:bg-gradient-to-r hover:from-[rgba(0,0,0,0.08)] hover:to-[rgba(0,0,0,0.08)] hover:bg-white',
    'border-solid  border-gray100',
    'hover:shadow-4 focus:shadow-4',
    location === 'start' && 'rounded-l-md border-r-1/2 ',
    location === 'end' && 'rounded-r-md border-l-1/2',
    location === 'middle' && 'border-x-1/2',
    active && 'bg-primary-300 text-white hover:text-white',
    !active && 'active:bg-gray100',
    props.className,
  );

  const typographyClassNames = twMerge('h-6', props.typographyClassName);

  return (
    <button type="button" className={buttonClassNames} onClick={onClick}>
      {iconProps && <Icon {...iconProps} />}
      {title && (
        <Typography
          className={typographyClassNames}
          variant="body-large-bold"
          as="p"
        >
          {title}
        </Typography>
      )}
    </button>
  );
};
